<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aenCJu/tc-custom/1.png?1684514924680?1705056298426" alt="This image is the cover for the book Oh No, Raleigh Scott"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Oh No, Raleigh Scott
      </h1>
      <p class="bookDescription body article font2">
        <p>Five-year-old Raleigh Scott Carter is an irresistibly mischievous little boy. He acts out his creative humor in unconventional pranks.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Carter
      </h2>
      
      <p class="authorDescription body article">Susan Carter lives in Wilmington, NC, where she and her husband raised their four children who have been the creative spark for her stories. She graduated from Converse College in Spartanburg, SC, where she majored in English literature.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?065c9f70